export default __webpack_public_path__ + "static/media/autorestart-negative.8a1296c6.svg";